import { Router as ReachRouter } from '@reach/router';
import styled from 'styled-components/macro';
import { layout, media } from '../../theme/tokens';

export const AppContainer = styled.main`
  padding-top: ${layout.mobileNavHeight};
  min-height: 100vh;
  font-family: ${({ theme }) => theme.fontFamily};

  ${media.md`
    padding-top: 0;
    padding-left: ${layout.sidebarWidth};
  `}
`;

export const Router = styled(ReachRouter)`
  display: grid;
  grid-template-rows: minmax(0, 1fr);
  grid-template-areas: 'content';
  min-width: 0;
`;
